import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var NormalFontSvg = function NormalFontSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    clipPath: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.54 1 0 23.177l1.484.505 2.382-7.006h4.967v-1.568H4.4l4.264-12.54h2.43l1.063 3.126 1.484-.505L12.216 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.479 6.532h3.862L24 23.177l-1.484.505-1.771-5.21h-8.67l-1.771 5.21-1.484-.505zm-1.871 10.373h7.604L17.218 8.1h-1.617z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
export var NormalFont = function NormalFont(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: NormalFontSvg
  }));
};